import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class CancelService {
	private _cancel = new Subject<boolean>();

	public cancel$ = this._cancel.asObservable();

	constructor() {}

	cancel() {
		this._cancel.next(true);
	}
}
